// Mock data for Amar Stars LLC website

export const socialFeeds = {
  tonymoly: [
    {
      id: 1,
      platform: 'instagram',
      image: '/images/tonymoly-brand.webp',
      caption: 'New skincare arrivals at TONYMOLY Mongolia',
      likes: 245,
      date: '2 days ago'
    },
    {
      id: 2,
      platform: 'facebook',
      image: '/images/tonymoly-brand.webp',
      caption: 'Discover the perfect skincare routine',
      likes: 312,
      date: '4 days ago'
    },
    {
      id: 3,
      platform: 'instagram',
      image: '/images/tonymoly-brand.webp',
      caption: 'Premium Korean beauty innovation',
      likes: 189,
      date: '1 week ago'
    }
  ],
  portmeirion: [
    {
      id: 4,
      platform: 'instagram',
      image: '/images/portmeirion-brand.webp',
      caption: 'Timeless elegance for your dining table',
      likes: 156,
      date: '3 days ago'
    },
    {
      id: 5,
      platform: 'facebook',
      image: '/images/portmeirion-brand.webp',
      caption: 'British craftsmanship meets modern living',
      likes: 203,
      date: '5 days ago'
    },
    {
      id: 6,
      platform: 'instagram',
      image: '/images/portmeirion-brand.webp',
      caption: 'Elevate your home with Portmeirion',
      likes: 178,
      date: '1 week ago'
    }
  ],
  ecover: [
    {
      id: 7,
      platform: 'facebook',
      image: '/images/ecover-brand.jpg',
      caption: 'Breathe cleaner air with Ecover solutions',
      likes: 134,
      date: '2 days ago'
    },
    {
      id: 8,
      platform: 'instagram',
      image: '/images/ecover-brand.jpg',
      caption: 'Sustainable living starts at home',
      likes: 167,
      date: '6 days ago'
    },
    {
      id: 9,
      platform: 'facebook',
      image: '/images/ecover-brand.jpg',
      caption: 'Creating healthier indoor environments',
      likes: 142,
      date: '1 week ago'
    }
  ]
};

export const storeLocations = {
  tonymoly: [
    { 
      id: 1, 
      name: 'Shangri-La Mall TONYMOLY 1', 
      floor: '2nd Floor, Shangri-La Mall', 
      address: 'Ulaanbaatar, Mongolia',
      phone: '+976 7500 8899-1',
      hours: '10:00 – 21:00'
    },
    { 
      id: 2, 
      name: 'Grand Plaza TONYMOLY 2', 
      floor: '1st Floor, Grand Plaza, West 4-Way Intersection', 
      address: 'Ulaanbaatar, Mongolia',
      phone: '+976 7011 4045',
      hours: '11:00 – 21:00'
    },
    { 
      id: 3, 
      name: 'Peace Mall Area TONYMOLY 3', 
      floor: 'In front of Peace Mall Bus Stop, Peace Avenue', 
      address: 'Ulaanbaatar, Mongolia',
      phone: '+976 11 321295',
      hours: '11:00 – 20:00'
    },
    { 
      id: 4, 
      name: 'KH Apartment TONYMOLY 4', 
      floor: '1st Floor, KH Apartment, East of Peace Bridge', 
      address: 'Khan-Uul District, Ulaanbaatar',
      phone: '+976 7500 8899-3',
      hours: '11:00 – 19:00'
    },
    { 
      id: 5, 
      name: 'E-Mart (10th Microdistrict) TONYMOLY', 
      floor: '3rd Floor, E-Mart', 
      address: 'Bayangol District, Ulaanbaatar',
      phone: '+976 7500 8899-4',
      hours: '09:00 – 22:00'
    },
    { 
      id: 6, 
      name: 'E-Mart Khan-Uul TONYMOLY 6', 
      floor: '3rd Floor, E-Mart', 
      address: 'Khan-Uul District, Ulaanbaatar',
      phone: null,
      hours: '09:00 – 22:00'
    },
    { 
      id: 7, 
      name: 'E-Mart Tengger Plaza TONYMOLY 7', 
      floor: '1st Floor, Tengger Plaza', 
      address: 'Bayanzurkh District, Ulaanbaatar',
      phone: null,
      hours: '09:00 – 22:00'
    },
    { 
      id: 8, 
      name: 'Sila Centre TONYMOLY 8', 
      floor: '2nd Floor, Sila Centre', 
      address: 'Khan-Uul District, Ulaanbaatar',
      phone: null,
      hours: '10:00 – 21:00'
    }
  ],
  portmeirion: [
    { 
      id: 1, 
      name: 'Shangri-La Mall - Portmeirion Main Store', 
      floor: '2nd Floor, Shangri-La Mall', 
      address: 'Ulaanbaatar, Mongolia',
      phone: '+976 7500 8899',
      hours: '10:00 – 21:00'
    },
    { 
      id: 2, 
      name: 'KH Apartment - Portmeirion Concept Store', 
      floor: '1st Floor, KH Apartment, East of Peace Bridge', 
      address: 'Khan-Uul District, Ulaanbaatar',
      phone: '+976 7500 8899',
      hours: '11:00 – 19:00'
    }
  ],
  ecover: [
    { 
      id: 1, 
      name: 'KH Apartment - Ecover Showroom', 
      floor: '1st Floor, KH Apartment, East of Peace Bridge', 
      address: 'Khan-Uul District, Ulaanbaatar',
      phone: '+976 7500 8899',
      hours: '11:00 – 19:00'
    }
  ]
};

export const contactFormHandler = (formData) => {
  // Mock form submission
  console.log('Form submitted:', formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Thank you for your inquiry. We will get back to you soon.' });
    }, 1000);
  });
};
